import { Entity, Field } from "typegraph";

import ProgramTrack from "./ProgramTrack";

@Entity({one: "programTrack", many: "programTrackUserByUsers"})
export default class ProgramTrackUser {

	@Field()
	public id: number;

	@Field({entity: ProgramTrack})
	public programTrack: ProgramTrack;

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/ProgramTrackUser.ts